import { FC, PropsWithChildren } from 'react'

import { Page } from '@revolut-internal/ui-kit'

import { PageHeader } from 'modules/Monitoring/components/PageHeader/PageHeader'
import { RtmPermissionsGate } from 'modules/Monitoring/components/RtmPermissionsGate/RtmPermissionsGate'

export const Root: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Page>
      <PageHeader />

      <Page.Main>
        <RtmPermissionsGate
          permissions={[
            'analytics.view.queues.details.list',
            'analytics.view.agents.attendance.details.list',
          ]}
          matchType="any"
          variant="widget"
        >
          {children}
        </RtmPermissionsGate>
      </Page.Main>
    </Page>
  )
}
